import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { withCookies } from "react-cookie";
import {
  Grid,
  Paper,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableSortLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  MenuItem,
  TableContainer,
  TablePagination,
  IconButton,
  CircularProgress,
} from "@material-ui/core";
import { ExpandMore, LastPage, FirstPage, KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import withWidth from "@material-ui/core/withWidth";
import PropTypes from "prop-types";

import { GetAllInterven, GetInterventionRecherche } from "./../../Helpers/Get/Interven";
import { GetAllConcess } from "./../../Helpers/Get/Concess";
import { GetAllCimetier } from "./../../Helpers/Get/Cimetier";
import { GetAllLieu } from "./../../Helpers/Get/Lieu";
import Opposition from "./../Global/OppositionTablette";
import { GetAllSociete } from "./../../Helpers/Get/Societe";
import { de } from "date-fns/locale";

var _ = require("lodash");

const headCells = [
  { id: "DATETRAVAUX", label: "Date d'exécution", sortable: true },
  { id: "EMPL_NATURE", label: "Nature", sortable: true },
  { id: "SUIVITRAV", label: "Suivi", sortable: true },
  { id: "INTERVENANT_NOM", label: "Intervenant", sortable: true },
  { id: "TYPECIME", label: "Cimetière", sortable: true },
  { id: "EMPLACEMENT_LIEU", label: "Emplacement", sortable: true },
];

const styles = {
  grid: {
    alignItems: "stretch",
    flex: 1,
    overflow: "auto",
  },
  grid_item: {
    display: "flex",
    flexDirection: "column",
    paddingBottom: 10,
    paddingTop: 10,
  },
  paper: {
    flex: 1,
    padding: 16,
  },
  linkToSheet: {
    "&:hover": {
      backgroundColor: "red",
    },
  },
   visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
};

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

 return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell key={headCell.id} align="left" sortDirection={orderBy === headCell.id ? order : false}>
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id && headCell.sortable ? order : "asc"}
              onClick={headCell.sortable ? createSortHandler(headCell.id) : null}
              hideSortIcon={!headCell.sortable}
            >
              {headCell.label}
              {orderBy === headCell.id && headCell.sortable ? <span style={styles.visuallyHidden}>{order === "desc" ? "sorted descending" : "sorted ascending"}</span> : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}


function getComparator(order, orderBy) {
  return order === "desc" ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

function descendingComparator(a, b, orderBy) {
  if (orderBy.includes(".")) {
    b = b[orderBy.split(".")[0]][orderBy.split(".")[1]];
    a = a[orderBy.split(".")[0]][orderBy.split(".")[1]];
  } else {
    b = b[orderBy];
    a = a[orderBy];
  }

  if (b < a) {
    return -1;
  }
  if (b > a) {
    return 1;
  }
  return 0;
}


function TablePaginationActions(props) {
  const { count, page, rowsPerPage, onChangePage } = props;

  const handleFirstPageButtonClick = (event) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div style={{ display: "flex" }}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
        <FirstPage />
      </IconButton>

      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
        <KeyboardArrowRight />
      </IconButton>
      <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
        <LastPage />
      </IconButton>
    </div>
  );
}

class CTravaux extends Component {
  static propTypes = {
    width: PropTypes.oneOf(["xl", "lg", "md", "sm", "xs"]).isRequired,
  };

  constructor(props) {
    super(props);

    this.CONCESS = [];
    this.LIEU = [];
    this.CIMETIER = [];

    this.state = {
      INTERVEN: [],
      SELECTED_INTERVEN: [],
      INTERV_AFFICHE: [],
      CIRCULARLOADER: true,
      SOCIETE: [],
      SELECTED_CIMETIER: 0,
      REDIRECT: null,
      listeInterven: 0,
      rowsPerPage: 10,
      currentPage: 0,  
      order: "asc",
      orderBy: "DATETRAVAUX",
      selectedCimetiere: "",
      selectedIntervention:"",
      selectedSuivitrav:3
    };

    props.changeTitle(props.title);
  }

  componentDidMount = () => {
    let cleApi = this.props.cookies.get(encodeURIComponent(btoa("APIKEY")));
    Opposition(cleApi);

    GetAllConcess().then((concess) => {
      this.CONCESS = concess;
    });

    GetAllCimetier(1).then((cimetier) => {
        this.CIMETIER = cimetier;
    });

    GetAllLieu().then((lieu) => {
      this.LIEU = lieu;
    });

    GetAllInterven().then((interven) => {
      let interv = _.orderBy(interven, "DATETRAVAUX", "desc");

      let currentInterv = _.filter(interv, (i) => {
        return i.SUIVITRAV === this.state.selectedSuivitrav;
      });

      this.setState({
        INTERVEN: currentInterv,
        INTERV_AFFICHE: currentInterv,
        CIRCULARLOADER: false,
      });
    });

    GetAllSociete().then((societe) => {
      this.setState({ SOCIETE: societe });
    });
  };

   handleRequestSort = (_, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === "asc";

    this.setState({
      order: isAsc ? "desc" : "asc",
      orderBy: property,
    });
  };

  _cree_chaine_famille = (id) => {
    let CONCESS = _.find(this.CONCESS, { COCLEUNIK: id });

    if (CONCESS !== undefined) {
      return CONCESS.FAMILLE;
    } else {
      return "";
    }
  };

  _cree_chaine_suivi_travaux = (suivi) => {
    switch (suivi) {
      case 2:
        return "En attente";
      case 3:
        return "En cours";
      case 4:
        return "Suspendu";
      case 5:
        return "Terminé";
      default:
        return "Inconnu";
    }
  };

  _cree_chaine_intervenant_type = (interven) => {
    switch (interven.INTERVENANT_TYPE) {
      case 2:
        let nom = "";

        if (interven.INTERVENANT_NOM !== "") {
          nom = interven.INTERVENANT_NOM;
        } else {
          let soc = _.find(this.state.SOCIETE, { SOCLEUNIK: interven.SOCLEUNIK });

          if (soc !== undefined) nom = soc.NOMSOCIETE;
        }

        return nom;
      case 3:
        return "Particulier";
      default:
        return "Collectivité";
    }
  };

  _cree_chaine_emplacement = (interven) => {
    var empl = "";

    let LIEU = _.find(this.LIEU, ["LICLEUNIK", interven.LICLEUNIK]);

    if (LIEU !== undefined && LIEU !== "") {
      if (LIEU.EMPLACEMENT.CARRE.includes("Provisoire") || LIEU.EMPLACEMENT.CARRE.includes("Non affect")) {
        let CONCESS = _.find(this.CONCESS, ["COCLEUNIK", interven.COCLEUNIK]);

        if (CONCESS !== undefined && CONCESS !== "") {
          empl = CONCESS.EMPL;
        }
      } else {
        empl = _.filter([
          _.filter([LIEU.EMPLACEMENT.TYPECAR, LIEU.EMPLACEMENT.CARRE]).join(" "),
          _.filter([LIEU.EMPLACEMENT.TYPERG, LIEU.EMPLACEMENT.RANG]).join(" "),
          _.filter([LIEU.EMPLACEMENT.TYPEFOS, LIEU.EMPLACEMENT.TOMBE]).join(" "),
        ]).join(" - ");

        const reg = /^(.*)\/(.*) (\d+)\/(\d+)(.*)$/;

        if (reg.test(empl)) {
          const TYPESEC = LIEU.EMPLACEMENT.TYPECAR.split("/")[0];
          const SECTION = LIEU.EMPLACEMENT.CARRE.split("/")[0];
          const TYPECAR = LIEU.EMPLACEMENT.TYPECAR.split("/")[1];
          const CARRE = LIEU.EMPLACEMENT.CARRE.split("/")[1];

          empl = _.filter([
            _.filter([TYPESEC, SECTION]).join(" "),
            _.filter([TYPECAR, CARRE]).join(" "),
            _.filter([LIEU.EMPLACEMENT.TYPERG, LIEU.EMPLACEMENT.RANG]).join(" "),
            _.filter([LIEU.EMPLACEMENT.TYPEFOS, LIEU.EMPLACEMENT.TOMBE]).join(" "),
          ]).join(" - ");
        }
      }
    }

    return empl;
  };

    _cree_chaine_cimetier = (typecime) => {
      let cim = _.find(this.CIMETIER, ["NUMCIME", typecime]);
  
      if (cim !== undefined) {
        return cim.NOMCIME;
      }
    };

  _handle_change_combo_listeInterven = (event) => {
    // set l'id de la date dans le state
    const idIntervention = event.target.value;

    // set l'id de la date dans le state
    this.setState({selectedIntervention: idIntervention}, () =>{
      this.rechercherIntervention();
    })
  };

  _handle_change_combo_cimetier = (event) => {
    // récupère l'id du cimetière passé en paramètre
    const idCimetiere = event.target.value; 

    // set l'id du cimetière dans le state
   this.setState({selectedCimetiere: idCimetiere}, () =>{
      this.rechercherIntervention();
    })
  };

  _handle_change_combo_suivi = (event) => {
     // récupère l'id du suivi passé en paramètre
    const suivi = event.target.value;

    // set l'id du suivi dans le state
    this.setState({selectedSuivitrav: suivi}, () =>{
      this.rechercherIntervention();
    })
  };

 // rechercher une intervention par paramètre de recherche
    rechercherIntervention = () =>{
      const interventions = this.state.selectedIntervention;
      const idCimetiere = this.state.selectedCimetiere;
      const suivitrav = this.state.selectedSuivitrav;

      // tri la liste des interventions par paramètre de recherche
      GetInterventionRecherche(interventions,idCimetiere,suivitrav).then((interv) => {
        this.setState({
          INTERV_AFFICHE: interv,
          loader: false,
          currentPage: 0, 
          EXPANDED: -1
        });
      });
    }

  _handle_change_tablepage = (event, newPage) => {
    this.setState({ currentPage: newPage });
  };

  _handle_change_tablerowperpage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, currentPage: 0 });
  };

    _handle_click_intervention_in_list = (interven) => (event) => {
    event.preventDefault();

    this.setState({
      REDIRECT: `${interven.I0CLEUNIK}`,
    });
  };
  
  

  render() {
    console.log("RENDER TRAVAUX");

    const { width } = this.props;

    if (this.state.REDIRECT !== null) {
      return <Redirect to={`/consulter/fiche-travaux/${this.state.REDIRECT}`} push />;
    }

    return (
      <Grid container alignItems="baseline" justify="center" style={styles.grid}>
        <Grid item xs={11} style={styles.grid_item}>
          <Paper style={styles.paper}>
            <Typography variant="h6" gutterBottom style={{ marginBottom: 24 }}>
              Liste des interventions
            </Typography>

            <TextField select fullWidth margin="normal" label="Interventions" value={this.state.selectedIntervention} onChange={this._handle_change_combo_listeInterven}>
              <MenuItem value={0}>Toutes les interventions</MenuItem>
              <MenuItem value={1}>Interventions du jour</MenuItem>
            </TextField>

            <TextField select fullWidth margin="normal" label="Cimetière" value={this.state.selectedCimetiere} onChange={this._handle_change_combo_cimetier}>
              <MenuItem value="">Indifférent</MenuItem>
              {this.CIMETIER.map((cimetier) => (
                <MenuItem key={cimetier.id} value={cimetier.NUMCIME}>
                  {cimetier.NOMCIME}
                </MenuItem>
              ))}
            </TextField>

            <TextField select fullWidth margin="normal" label="Suivi" value={this.state.selectedSuivitrav} onChange={this._handle_change_combo_suivi}>
              <MenuItem value={1}>Inconnu</MenuItem>
              <MenuItem value={2}>En attente</MenuItem>
              <MenuItem value={3}>En cours</MenuItem>
              <MenuItem value={4}>Suspendu</MenuItem>
              <MenuItem value={5}>Terminé</MenuItem>
            </TextField>

            {this.state.CIRCULARLOADER ? <CircularProgress style={{ position: "absolute", left: "50%", right: "50%", top: "50%", bottom: "50%" }} /> : null}

            {width === "xs" || width === "sm" ? (
              <div>                
              <Paper elevation={0} style={{ display: "flex", padding: "0 16px" }}>
                  <TextField
                    select
                    label="Tri par :"
                    value={this.state.orderBy}
                    style={{ width: "25ch", marginRight: 16, marginBottom: 16 }}
                    onChange={(e) => {
                      this.setState({
                        orderBy: e.target.value,
                        EXPANDED: null,
                      });
                    }}
                  >
                    <MenuItem value="DATETRAVAUX">Date d'exécution</MenuItem>
                  </TextField>

                  <TextField
                    select
                    label="Ordre :"
                    value={this.state.order}
                    style={{ width: "25ch" }}
                    onChange={(e) => {
                      this.setState({ order: e.target.value, EXPANDED: null });
                    }}
                  >
                    <MenuItem value="asc">Croissant</MenuItem>
                    <MenuItem value="desc">Décroissant</MenuItem>
                  </TextField>
              </Paper>

              <TableContainer component={Paper} style={{ marginTop: 24 }}>
                {stableSort(this.state.INTERV_AFFICHE, getComparator(this.state.order, this.state.orderBy))
                    .slice(this.state.currentPage * this.state.rowsPerPage, this.state.currentPage * this.state.rowsPerPage + this.state.rowsPerPage)
                    .map((row, index) => {
                      return (
                        <Accordion key={index} elevation={0} expanded={this.state.EXPANDED === index ? true : false} onChange={() => this.setState({ EXPANDED: index })}>
                          <AccordionSummary expandIcon={<ExpandMore />}>
                            <Typography variant="body2" gutterBottom>
                              {row.DATETRAVAUX !== "" ? `${new Date(row.DATETRAVAUX).toLocaleDateString("fr-FR")}` : null}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails onClick={this._handle_click_intervention_in_list(row)}>
                          <Table>
                            <TableBody>
                              <TableRow>
                                <TableCell>Date d'exécution</TableCell>
                                <TableCell>{row.DATETRAVAUX !== "" ? `${new Date(row.DATETRAVAUX).toLocaleDateString("fr-FR")}` : null}</TableCell>
                              </TableRow>

                              <TableRow>
                                <TableCell>Nature</TableCell>
                                <TableCell>{row.EMPL_NATURE}</TableCell>
                              </TableRow>
                              
                              <TableRow>
                                <TableCell>Suivi</TableCell>
                                <TableCell>{this._cree_chaine_suivi_travaux(row.SUIVITRAV)}</TableCell>
                              </TableRow>

                              <TableRow>
                                <TableCell>Intervenant</TableCell>
                                <TableCell>{this._cree_chaine_intervenant_type(row)}</TableCell>
                              </TableRow>

                              <TableRow>
                                <TableCell>Cimetière</TableCell>
                                <TableCell>
                                {this._cree_chaine_cimetier(row.TYPECIME)}
                              </TableCell>
                              </TableRow>

                              <TableRow>
                                <TableCell>Emplacement</TableCell>
                                <TableCell>{this._cree_chaine_emplacement(row)}</TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
              </TableContainer>
            </div>
            ) : (
              <TableContainer component={Paper} style={{ marginTop: 24 }}>
                <Table>
                  <EnhancedTableHead order={this.state.order} orderBy={this.state.orderBy} onRequestSort={this.handleRequestSort} />
                  <TableBody>
                       {stableSort(this.state.INTERV_AFFICHE, getComparator(this.state.order, this.state.orderBy))
                       .slice(this.state.currentPage * this.state.rowsPerPage, this.state.currentPage * this.state.rowsPerPage + this.state.rowsPerPage)
                       .map((row, index) => {     
                          return (
                            <TableRow key={index} hover={true} style={{ cursor: "pointer" }} onClick={this._handle_click_intervention_in_list(row)}>
                              <TableCell>{row.DATETRAVAUX !== "" ? `${new Date(row.DATETRAVAUX).toLocaleDateString("fr-FR")}` : null}</TableCell>
                              <TableCell>{row.EMPL_NATURE}</TableCell>
                              <TableCell>{this._cree_chaine_suivi_travaux(row.SUIVITRAV)}</TableCell>
                              <TableCell>{this._cree_chaine_intervenant_type(row)}</TableCell>
                              <TableCell>{this._cree_chaine_cimetier(row.TYPECIME)}</TableCell>
                              <TableCell>{this._cree_chaine_emplacement(row)}</TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

            <Table component={Paper} elevation={0}>
              <TableBody>
                <TableRow>
                <TablePagination
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  colSpan={3}
                  count={this.state.INTERV_AFFICHE.length}
                  rowsPerPage={this.state.rowsPerPage}
                  page={this.state.currentPage}
                  labelRowsPerPage="Nombre de lignes"
                  labelDisplayedRows={({ from, to, count }) =>
                    width !== "xs" && width !== "sm" ? (count > 0 ? `De ${from} à ${to === -1 ? count : to} sur ${count !== -1 ? count : to} résultats` : `Aucun résultat`) : null
                  }
                  onChangePage={this._handle_change_tablepage}
                  onChangeRowsPerPage={this._handle_change_tablerowperpage}
                  ActionsComponent={TablePaginationActions}
                />
                </TableRow>
              </TableBody>
            </Table>
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

export default withWidth()(withCookies(CTravaux));
